import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<{
  increasePadding: boolean;
}>({
  name: 'SelectableCard',
})(({ spacing, brandColors, typography: { pxToRem } }, props) => ({
  selectableCard: {
    borderRadius: pxToRem(8),
    backgroundColor: brandColors.white,
    border: `1px solid ${brandColors.tintsOffWhite40}`,
    padding: props.increasePadding ? spacing(1) : spacing(0),
    cursor: 'pointer',
    '&:hover': {
      borderColor: brandColors.tintsNeutral20,
    },
    display: 'flex',
    alignItems: 'center',
  },
  selected: {
    outline: `${pxToRem(2)} solid ${brandColors.primaryMain}`,
    outlineOffset: pxToRem(-1),
    '&:hover': {
      outlineColor: brandColors.primaryMain,
    },
  },
  srOnly: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
  },
}));

export default useStyles;
